<template>
  <div class="LoginRegister lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto lxn-border-round">
    <div class="LoginRegister-d0">
      <CurveWithSvg>
        <template v-slot:default>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" rightIcon="" leftIcon="arrowLeft" centerText=""></TopNav>
        </template>
        <template v-slot:svg>
          <svg class="lxn-w100 lxn-h100 lxn-display-block" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 250 250"><g class="LoginRegister-F"><path d="M85.91 26.396c-5.3 0-9.6.87-9.6 1.95v4.6c0 1.07 4.3 1.95 9.6 1.95 5.3 0 9.6-.87 9.6-1.95v-4.6c0-1.08-4.3-1.95-9.6-1.95z"/><path d="M85.91-.004l-.78 26.4h1.55l-.77-26.4z"/></g><path d="M209.32 167.956h31.94v28h-31.94z" class="LoginRegister-D"/><path d="M191.45 112.606H216v83.34h-24.55z" class="LoginRegister-E"/><path d="M177.14 143.356h26.58v52.6h-26.58z" class="LoginRegister-D"/><path d="M166.42 152.176h21.45v43.77h-21.45z" class="LoginRegister-F"/><path d="M164.27 153.926h19.55v42.02h-19.55z" class="LoginRegister-E"/><path d="M152.35 133.106h13.1v62.84h-13.1z" class="LoginRegister-D"/><path d="M144.72 111.176h11.68v84.77h-11.68z" class="LoginRegister-E"/><path d="M125.89 92.576h24.67v103.36h-24.67z" class="D"/><g class="LoginRegister-E"><path d="M116.28 171.246h16.05v24.7h-16.05z"/><path d="M124.31 160.696v35.25h-6.04v-35.25h1.9v-4.95h3.45v4.95z"/></g><path d="M107.95 165.526h12.07v30.42h-12.07zm-12.65 3.97h12.4v26.45H95.3z" class="LoginRegister-D"/><g class="LoginRegister-E"><path d="M104.21 195.946h-34v-21.4l.25-13.86 2.3-123.3 6.9-7 .1-.1.6.1 15.15 2.68 3.32.6h.01l4.52 135.82z"/><path d="M52.47 160.696h19.78v35.25H52.47z"/></g><path d="M34.12 171.246v-78.66l7.63-1.43v4.77l14.06-2.15 3.57 1.67v100.35H34.12v-24.55z" class="LoginRegister-D"/><path d="M218.5 148.366h17.4v47.58h-17.4z" class="LoginRegister-E"/><g class="LoginRegister-D"><path d="M250 153.346v42.6h-15.6v-28-14.65l4.6.06v-3.58h2.38v-5h2.63v5l1.1.04-.02 3.53zm-19.6-90.8h-56.35v-15.26c.9.35 1.78.8 2.58 1.34 14.82-9.14 24.6 2.2 26.8 6.93s26.97 7 26.97 7z"/><path d="M123.57 62.546h56.35v-15.26c-.9.35-1.78.8-2.58 1.34-14.82-9.14-24.6 2.2-26.8 6.93-2.22 4.73-26.97 7-26.97 7zm77.228 53.56h15.2v.8h-15.2zm0 3.48h15.2v.8h-15.2zm0 3.5h15.2v.8h-15.2zm0 3.48h15.2v.8h-15.2zm0 3.5h15.2v.8h-15.2zm0 3.48h15.2v.8h-15.2zm0 3.5h15.2v.8h-15.2zm0 3.48h15.2v.8h-15.2z"/></g><path d="M238.244 171.187h7.5v.55h-7.5zm0 2.4h7.5v.55h-7.5zm0 2.4h7.5v.55h-7.5zm0 2.4h7.5v.55h-7.5zm0 2.38h7.5v.55h-7.5zm0 2.4h7.5v.55h-7.5zm0 2.4h7.5v.55h-7.5zm0 2.4h7.5v.55h-7.5z" class="E"/><g class="LoginRegister-D"><use xlink:href="#B"/><use xlink:href="#B" x="2.7"/><use xlink:href="#B" x="5.41"/><use xlink:href="#B" x="8.12"/><use xlink:href="#B" x="10.82"/><use xlink:href="#B" y="3.096"/><use xlink:href="#B" x="2.7" y="3.096"/><use xlink:href="#B" x="5.41" y="3.096"/><use xlink:href="#B" x="8.12" y="3.096"/><use xlink:href="#B" x="10.82" y="3.096"/><use xlink:href="#B" y="6.193"/><use xlink:href="#B" x="2.7" y="6.193"/><use xlink:href="#B" x="5.41" y="6.193"/><use xlink:href="#B" x="8.12" y="6.193"/><use xlink:href="#B" x="10.82" y="6.193"/><use xlink:href="#B" y="9.28"/><use xlink:href="#B" x="2.7" y="9.28"/><use xlink:href="#B" x="5.41" y="9.28"/><use xlink:href="#B" x="8.12" y="9.28"/><use xlink:href="#B" x="10.82" y="9.28"/><use xlink:href="#B" y="12.376"/><use xlink:href="#B" x="2.7" y="12.376"/><use xlink:href="#B" x="5.41" y="12.376"/><use xlink:href="#B" x="8.12" y="12.376"/><use xlink:href="#B" x="10.82" y="12.376"/></g><path d="M194.18 146.126h2.35v.98h-2.35zm0 1.52h1.22v1.22h-1.22zm-11.48-2.3h1.28v1.28h-1.28zm-.7 4.05h1.2v1.2H182zm7 .6h1.2v1.2h-1.2z" class="E"/><g class="LoginRegister-D"><path d="M181.5 157.706h1.25v1.25h-1.25zm0 2.4h1.25v1.25h-1.25z"/><use xlink:href="#C"/><use xlink:href="#C" x="2.22"/><use xlink:href="#C" x="2.22" y="2.86"/><use xlink:href="#C" y="5.72"/><use xlink:href="#C" x="2.22" y="5.72"/><use xlink:href="#C" y="8.58"/></g><path d="M158.9 133.106h6.55v1.43h-6.55zm0 12.53h6.55v1.43h-6.55zm-30-24.8h6.2v1.4h-6.2zm7.24 2.83h6.2v1.4h-6.2zm-7.24 5.64h6.2v1.4h-6.2zm7.24 0h6.2v1.4h-6.2zm-10.26-24.9h20.26v1.3H125.9z" class="F"/><g class="LoginRegister-D"><path d="M79.73 30.286l13.03 140.95 6.04-137.78-19.07-3.17z"/><path d="M79.73 30.286l-5.88 140.95-1.1-134.28 7-6.67z"/></g><g class="LoginRegister-E"><use xlink:href="#D"/><use xlink:href="#D" x="4.41" y="3.34"/><use xlink:href="#D" x="9.54" y="2.48"/><use xlink:href="#D" x="1.4" y="16.36"/><use xlink:href="#D" x="2.02" y="19.02"/><use xlink:href="#D" x="2.71" y="21.67"/><path d="M91.9 64.096h1.4v1.42h-1.4zm-.36 3.13h1.4v1.4h-1.4zm-2.98 5.84h1.4v1.4h-1.4zm.24 3.3h1.4v1.4h-1.4z"/></g><path d="M81.72 84.726h1.42v1.4h-1.42zm-.27 5.6h1.42v1.4h-1.42zm2.07 11.92h1.4v1.4h-1.4zm-4.73 2.27h1.4v1.4h-1.4zm-13.05 28.6h20.98v62.84H65.74z" class="LoginRegister-D"/><path d="M81.32 166.596H98.8v29.35H81.32z" class="LoginRegister-E"/><path d="M191.45 112.606H198v30.75h-6.55z" class="LoginRegister-F"/><path d="M59.39 135.756H11.2v44.25l48.2 9.45v-53.7z" class="LoginRegister-D"/><path d="M55.8 93.776v77.47l-21.7-35.5v-43.17l7.63-1.43v4.77l14.06-2.15zm-21.03 102.17H.001v-71.6l31.26 11.32v.1l3.5 60.04zm118.44-30.42h13.2v30.42h-13.2z" class="LoginRegister-E"/><g class="LoginRegister-D"><use xlink:href="#C" x="-12.95" y="3.55"/><use xlink:href="#C" x="-10.73" y="3.55"/><use xlink:href="#C" x="-8.45" y="3.55"/><use xlink:href="#C" x="-6.23" y="3.55"/><use xlink:href="#C" x="-8.45" y="6.41"/><use xlink:href="#C" x="-6.23" y="9.28"/><use xlink:href="#C" x="-8.45" y="12.14"/><use xlink:href="#C" x="-6.23" y="12.14"/><use xlink:href="#C" x="-10.73" y="6.41"/><use xlink:href="#C" x="-12.95" y="9.28"/><use xlink:href="#C" x="-10.73" y="9.28"/><use xlink:href="#C" x="-12.95" y="12.14"/></g><defs ><path id="B" d="M220.285 150.742h1.97v1.97h-1.97z"/><path id="C" d="M169.91 171.606h1.47v1.47h-1.47z"/><path id="D" d="M85.55 35.696l-3.2-.67-.24-1.03 3.2.67.24 1.03z"/></defs></svg>
        </template>
      </CurveWithSvg>
    </div>
    <div class="LoginRegister-body lxn-w100">
      <div :class="[$store.getters.language.font, $store.getters.language.directionClass]" class="LoginRegister-title lxn-w100 lxn-title lxn-text-center">
        {{$store.getters.language.texts.LoginRegister_title}}
      </div>
      <div :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]" class="LoginRegister-text lxn-w100 lxn-text lxn-text-justify">
        {{$store.getters.language.texts.LoginRegister_text}}
      </div>
      <div class="LoginRegister-input">
        <customInput @focus="inputState='active'" @blur="inputState=''" :inputState="inputState" v-model="inputValue" :placeHolder="$store.getters.language.texts.LoginRegister_placeHolder" inputType="tel">
        </customInput>
      </div>
      <div class="LoginRegister-button lxn-w100">
        <CustomButton @click="sendConfirmationCode()" bgColor="#1EA5DE" iconRight="boxArrow" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" :iconRightPadding="8" :useLanguageDirection="true" textColor="#FFFFFF">
          {{$store.getters.language.texts.LoginRegister_button}}
        </CustomButton>
      </div>
      <div @click="checkGoogleSignInAndroid" v-if="phonegapMode" class="LoginRegister-button lxn-w100 lxn-text-en lxn-text-center">
        <a :href="scopedGoogleLoginUrl">
          Sign in with Google
        </a>
      </div>
      <div v-else class="LoginRegister-button lxn-w100">
        <div @click="appBusyTrue" class="lxn-display-table lxn-margin-auto">
          <GoogleLogin :params="params" :renderParams="renderParams" :onSuccess="onSuccess" :onFailure="onFailure"></GoogleLogin>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue'
import CurveWithSvg from '@/components/CurveWithSvg.vue'
import CustomButton from '@/components/CustomButton.vue'
import CustomInput from '@/components/CustomInput.vue'
import TopNav from '@/components/TopNav.vue'
import md5 from 'md5'
import GoogleLogin from 'vue-google-login'
import { LoaderPlugin } from 'vue-google-login'
import * as CONFIGS from '@/statics/configs.js'

let GoogleAuthPromise = null;
if(CONFIGS.APP_MODE != 'phonegap'){
  Vue.use(LoaderPlugin, {
      client_id: CONFIGS.googleAuth2ClientId
  });
  GoogleAuthPromise = Vue.GoogleAuth;
}

export default {
  name: 'LoginRegister',
  components: {
    CurveWithSvg,
    CustomButton,
    CustomInput,
    TopNav,
    GoogleLogin,
  },
  data: function() {
    var scopeToken = new Uint8Array(32);
    window.crypto.getRandomValues(scopeToken);
    scopeToken = md5(scopeToken.toString('hex'));
    return {
      scopeToken: scopeToken,
      inputValue: '',
      inputState: '',
      params: {
          client_id: CONFIGS.googleAuth2ClientId
      },
      renderParams: {
        width: 250,
        height: 50,
        longtitle: true
      },
      checkGoogleSignInAndroidTimeout: -1,
      checkGoogleSignInAndroidInterval: 1000,
    }
  },
  mounted: async function () {
    if(CONFIGS.APP_MODE != 'phonegap'){
      var auth2 = await GoogleAuthPromise;
      if(auth2.isSignedIn.get()){
        this.$store.commit('setAppBusy', true);
        this.onSuccess(auth2.currentUser.get());
      }
    }
  },
  computed: {
    phonegapMode: function () {
      return CONFIGS.APP_MODE == 'phonegap'
    },
    scopedGoogleLoginUrl: function () {
      return 'https://pwa.lexabms.com/user/google/login?' + this.scopeToken;
    }
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    appBusyTrue: function () {
      this.$store.commit('setAppBusy', true);
    },
    sendConfirmationCode: function () {
      if(!this.validateInput(this.inputValue)){
        this.inputState = 'error';
        alert(this.$store.getters.language.texts.LoginRegister_inputError);
      }else{
        this.$store.commit('setAppBusy', true);
        this.$store.dispatch('getLoginVerificationKey', this.inputValue).then(response => {
          if(response.data.status == 'success'){
            this.$store.commit('setUserUUID', response.data.user_uuid);
            this.$router.push('/loginConfirmationCode');
          }else{
            alert(this.$store.getters.language.texts.LoginRegister_serverResponseFail);
          }
        })
        .catch( () => {
          alert(this.$store.getters.language.texts.Common_internetError);
        })
        .finally(() => {
          this.$store.commit('setAppBusy', false);
        });
      }
    },
    validateInput: function (inputValue) {
      if( inputValue == ''){
        return false;
      }
      return true;
    },
    onSuccess: async function (googleUser) {
      var googleToken = googleUser.getAuthResponse().id_token;
      try {
        var serverResponse = await this.$store.dispatch('getUserUuidFromGoogleToken', {googleToken: googleToken});
        if(serverResponse.data.status == 'success'){
          this.$store.commit('setUserUUID', serverResponse.data.user_uuid);
          this.$store.commit('setLoginToken', serverResponse.data.aux_auth_token);
          this.$store.commit('setLoggedIn', true);
          this.$store.commit('saveState');
          this.$router.push('/lexaIntro');
        }else{
          alert(this.$store.getters.language.texts.LoginRegister_googleLoginFailed);
        }
      }
      catch (response) {
        alert(this.$store.getters.language.texts.LoginRegister_googleLoginFailed);
      }
      this.$store.commit('setAppBusy', false);
    },
    onFailure: function (error) {
      alert(JSON.stringify(error));

      this.$store.commit('setAppBusy', false);
      alert(this.$store.getters.language.texts.LoginRegister_googleLoginFailed);
    },
    checkGoogleSignInAndroid: function () {
      console.log("inside checkGoogleSignInAndroid")
      this.$store.commit('setAppBusy', true);
      clearTimeout(this.checkGoogleSignInAndroidTimeout);
      this.checkGoogleSignInAndroidTimeout = setTimeout( async () => {
        try {
          var serverResponse = await this.$store.dispatch('checkUserGoogleLogin', {scope: this.scopeToken});
          if(serverResponse.data.status == 'success'){
            this.$store.commit('setUserUUID', serverResponse.data.user_uuid);
            this.$store.commit('setLoginToken', serverResponse.data.aux_auth_token);
            this.$store.commit('setLoggedIn', true);
            this.$store.commit('saveState');
            this.$router.push('/lexaIntro');
          }else{
            alert(this.$store.getters.language.texts.LoginRegister_googleLoginFailed);
          }
          this.$store.commit('setAppBusy', false);
        }
        catch {
          this.checkGoogleSignInAndroidTimeout = setTimeout( () => {
            this.checkGoogleSignInAndroid();
          }, this.checkGoogleSignInAndroidInterval);
        }
      }, this.checkGoogleSignInAndroidInterval);
    },
  }
}
</script>

<style>
  .LoginRegister {
    background-color: #ffffff;
    padding: 18px;
    padding-top: 0;
  }
  .LoginRegister-d0 {
    height: 40vh;
  }
  .LoginRegister-title {
    margin-top: 20px;
    height: 30px;
    color: #1EA5DE;
    line-height: 30px;
  }
  .LoginRegister-text {
    color: #53636C;
    margin-top: 14px;
  }
  .LoginRegister-button {
    margin-top: 20px;
  }
  .LoginRegister-input {
    margin-top: 20px;
  }
  .LoginRegister-D {
    fill:#48bdef;
  }
  .LoginRegister-E {
    fill:#008cc7;
  }
  .LoginRegister-F {
    fill:#006792;
  }
  .D{fill:#4fbded}
  .E{fill:#0a8dc6}
  .F{fill:#010101}
</style>
